import { useState, useEffect } from "react";
import { Route, Routes } from 'react-router-dom';
import JsonData from "./data/data.json";

import SmoothScroll from "smooth-scroll";
import "./App.css";
import { Navigation } from "./components/navigation";
import { Footer } from "./components/footer";
import Footerdetail from "./components/Footerdetail";
import Home from "./Home"

import { PageNotFound } from "./components/pageNotFound";
import { Privacypolicy } from "./components/pages/privacypolicy";
import { Thanks } from "./components/thanks";




export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});


const App = () => {

  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
    <div className="social">
        
          <div className="pop">
          <a className="phonescreenstick" href="tel:18005691061">
            <img style={{ border: "0" }} src="img/18005691061wbg.png" alt="callus@18005691061" />
          </a>
        </div>
          
      </div>
      {/*
        <div className='social'>
        <div>
          <a className="whatsappscreen" href="https://api.whatsapp.com/send?phone=9118005691061" target="_blank" rel="noreferrer">
            <i className="fa fa-whatsapp"></i>
          </a>
        </div>
        <div>
          <a className="phonescreen" href="tel:18005691061">
            <i className="fa fa-phone"></i>
          </a>
        </div>
      </div>
      <Footerdetail data={landingPageData.Contact} />
        */}
      <Navigation />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="*" element={<PageNotFound />} />
        <Route path="/privacy-policy" element={<Privacypolicy />} />
        <Route path="/thanks" element={<Thanks />} />

        
      </Routes>
      
      <Footer data={landingPageData.Footer} />
    </div>

  );
};


export default App;
